import Icon from '@material-ui/icons/Group';

export default Icon;